import React, { useMemo, useState } from 'react';
import { Container, Row, Col, Image, Button } from 'react-bootstrap';
import Menu from '../sections/Menu';
import Footer from '../sections/Footer';
import heroImage from '../images/KW.jpg';
import PageMeta from '../seo/PageMeta';
import { buildContactPageStructuredData } from '../seo/structuredData';

function Kontakt() {
  const contactStructuredData = useMemo(
    () => [buildContactPageStructuredData("/kontakt")],
    []
  );

  const [formData, setFormData] = useState({
    name: '',
    companyName: '',
    phone: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch('https://formspree.io/f/xwpwddkd', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        alert('Wiadomość została wysłana!');
        setFormData({
          name: '',
          companyName: '',
          phone: ''
        });
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Wystąpił błąd podczas wysyłania wiadomości.');
    }
  };

  const labelStyle = {
    display: 'flex',
    flexDirection: 'column',
    fontSize: '0.875rem',
    fontWeight: '600',
    color: '#374151'
  };

  const inputStyle = {
    marginTop: '4px',
    padding: '8px 12px',
    fontSize: '0.875rem',
    border: '1px solid #d1d5db',
    borderRadius: '6px'
  };

  return (
    <>
      <PageMeta path="/kontakt" structuredData={contactStructuredData} />
      <Menu />
      <Container className="py-5 mt-5">
        <Row>
          <Col md={6} className="pe-md-4 contact-left">
            <h2 className="mb-2" style={{ fontSize: '1.8rem' }}>Formularz kontaktowy</h2>
            <p className="mb-4 contact-text" style={{ fontSize: '1rem', color: '#6b7280' }}>24 godziny, a może 5 minut? Zobacz, jak szybko odpowiadamy</p>
            <form onSubmit={handleSubmit} className="contact-form" style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <label style={labelStyle}>
                Imię
                <input 
                  name="name" 
                  value={formData.name} 
                  onChange={handleChange} 
                  type="text" 
                  placeholder="Wpisz swoje imię" 
                  style={inputStyle} 
                  required 
                />
              </label>
              <label style={labelStyle}>
                Nazwa firmy
                <input 
                  name="companyName" 
                  value={formData.companyName} 
                  onChange={handleChange} 
                  type="text" 
                  placeholder="Wpisz nazwę firmy" 
                  style={inputStyle} 
                  required 
                />
              </label>
              <label style={labelStyle}>
                Numer telefonu
                <input 
                  name="phone" 
                  value={formData.phone} 
                  onChange={handleChange} 
                  type="tel" 
                  placeholder="Wpisz numer telefonu" 
                  style={inputStyle} 
                  required 
                />
              </label>
              <button type="submit" style={{
                backgroundColor: '#2d6ff4',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                padding: '12px',
                borderRadius: '6px',
                fontSize: '1rem',
                fontWeight: '600',
                marginTop: '8px'
              }}>
                Wyślij
              </button>
            </form>
            <div className="contact-form">
              <p className="text-center mt-5 mb-5" style={{ fontSize: '1rem', color: '#6b7280' }}>
                lub od razu wybierz termin z kalendarza
              </p>
              <div className="text-center">
                <Button
                  className="button-default"
                  onClick={() => window.open('https://calendly.com/krzysztof-warda-egodziny/30min', '_blank')}
                >
                  Umów spotkanie
                </Button>
              </div>
            </div>
          </Col>

          <Col md={6} className="ps-md-4 mt-4 mt-md-0 d-flex flex-column align-items-center justify-content-start">
            <Image 
              src={heroImage} 
              alt="Kontakt" 
              fluid 
              className="mb-3"
              style={{ 
                maxWidth: '50%',
                borderRadius: '15px',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.15)'
              }}
            />
            <div className="text-center mb-3">
              <p style={{ fontSize: '1.3rem', fontWeight: '600', marginBottom: '4px', color: '#1f2937' }}>
                Krzysztof Warda
              </p>
              <p style={{ fontSize: '1rem', color: '#6b7280', marginBottom: '0' }}>
                Współzałożyciel eGodziny
              </p>
            </div>
            <div className="text-center mb-3">
              <p style={{ fontSize: '1.2rem', marginBottom: '1px' }}>
                <a href="tel:+48515800125" style={{ color: '#2d6ff4', textDecoration: 'none' }}>
                  +48 515 800 125
                </a>
              </p>
              <p style={{ fontSize: '1.2rem', marginBottom: '0' }}>
                <a href="mailto:krzysztof.warda@egodziny.pl" style={{ color: '#2d6ff4', textDecoration: 'none' }}>
                  krzysztof.warda@egodziny.pl
                </a>
              </p>
            </div>
            <blockquote style={{
              backgroundColor: '#f8f9fa',
              borderLeft: '4px solid #2d6ff4',
              borderRadius: '8px',
              padding: '20px',
              margin: '20px 0 0 0',
              fontStyle: 'italic',
              fontSize: '1rem',
              lineHeight: '1.6',
              color: '#6b7280',
              maxWidth: '80%'
            }}>
              "Nie łączysz się z szeregowym konsultantem. Znam produkt od podszewki."
            </blockquote>
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  );
}

export default Kontakt;
